import equal from 'fast-deep-equal';

const getMapOfPalettes = (palettes) =>
  palettes.reduce((accum, palette) => {
    const accumCopy = { ...accum };
    accumCopy[palette.id] = palette;
    return accumCopy;
  }, {});

const getCustomPalettesToUpdate = (initialCustomPalettes, currentCustomPalettes) => {
  if (equal(initialCustomPalettes, currentCustomPalettes)) return [];

  const initialCustomPalettesMap = getMapOfPalettes(initialCustomPalettes);
  const initialIds = Object.keys(initialCustomPalettesMap);

  const currentCustomPalettesMap = getMapOfPalettes(currentCustomPalettes);
  const currentIds = Object.keys(currentCustomPalettesMap);

  const intersection = initialIds.filter((element) => currentIds.includes(element));

  return intersection
    .map((id) => {
      const initialValue = initialCustomPalettesMap[id];
      const currentValue = currentCustomPalettesMap[id];
      if (!equal(initialValue, currentValue)) return currentValue;
      return null;
    })
    .filter(Boolean);
};

export default getCustomPalettesToUpdate;
